import ImagePlaceholder from "../../../../components/Placeholders/ImagePlaceholder";
import timePlaceholder from '../../../../assets/Images/wait.png'

import './InventoryAvailabilityDialog.css'

const InventoryAvailabilityDialog = ({ onClose, partId }) => {
  return (
    <div className="inventory-availability-dialog-component">
      <div className="header-dialog">
        <b>Inventory Availability</b>
        <button onClick={onClose} className="outlined icon">
          <i className="icon-cross"></i>
        </button>
      </div>
      <ImagePlaceholder image={timePlaceholder} title={"We are working on this section."} subtitle={""} />


    </div>)
}

export default InventoryAvailabilityDialog;